/**
 * @generated SignedSource<<0933b98efee62f87a502c2fb09d64af2>>
 * @relayHash f5528f55bdab5a02587ef6cd5262334d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059

import type { ConcreteRequest, Query } from 'relay-runtime';
export type TemplateMediaSessionUploadQuery$variables = {
  collectionId?: string | null | undefined;
  spaceKey?: string | null | undefined;
  templateIds: ReadonlyArray<string | null | undefined>;
};
export type TemplateMediaSessionUploadQuery$data = {
  readonly templateMediaSession: {
    readonly collections: ReadonlyArray<{
      readonly key: string | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined>;
    readonly configuration: {
      readonly clientId: string;
      readonly fileStoreUrl: string;
    };
    readonly uploadToken: {
      readonly duration: number | null | undefined;
      readonly value: string | null | undefined;
    };
  } | null | undefined;
};
export type TemplateMediaSessionUploadQuery = {
  response: TemplateMediaSessionUploadQuery$data;
  variables: TemplateMediaSessionUploadQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "collectionId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateIds"
},
v3 = {
  "kind": "ScalarField",
  "name": "value"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "collectionId",
        "variableName": "collectionId"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      },
      {
        "kind": "Variable",
        "name": "templateIds",
        "variableName": "templateIds"
      }
    ],
    "concreteType": "TemplateMediaSession",
    "kind": "LinkedField",
    "name": "templateMediaSession",
    "plural": false,
    "selections": [
      {
        "concreteType": "MapOfStringToString",
        "kind": "LinkedField",
        "name": "collections",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "key"
          },
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "MediaConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "fileStoreUrl"
          },
          {
            "kind": "ScalarField",
            "name": "clientId"
          }
        ]
      },
      {
        "concreteType": "TemplateMediaToken",
        "kind": "LinkedField",
        "name": "uploadToken",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "duration"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TemplateMediaSessionUploadQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TemplateMediaSessionUploadQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "f5528f55bdab5a02587ef6cd5262334d",
    "id": "7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059",
    "metadata": {},
    "name": "TemplateMediaSessionUploadQuery",
    "operationKind": "query",
    "text": "query TemplateMediaSessionUploadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},uploadToken{value,duration}}}"
  }
};
})();

(node as any).hash = "1d0108dcbf48addfcc8b1c4145c7178d";

export default node;
